import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["selectedTags", "list"];

  connect() {
    this.selectedCategories = new Set(); // Store selected categories
  }

  search(event) {
    let query = event.target.value.toLowerCase().trim();
    if (query.length === 0) {
      this.listTarget.style.display = "none";
      return;
    }
    this.listTarget.style.display = "block";

    this.listTarget.querySelectorAll("li").forEach((item) => {
      item.style.display = item.textContent.toLowerCase().includes(query) ? "block" : "none";
    });
  }

  select(event) {
    let categoryId = event.target.dataset.value;
    let categoryTitle = event.target.textContent;

    if (this.selectedCategories.size >= 3 || this.selectedCategories.has(categoryId)) {
      return;
    }

    this.selectedCategories.add(categoryId);
    this.updateHiddenField();

    this.addTag(categoryTitle, categoryId);
  }

  remove(event) {
    let categoryId = event.target.dataset.value;
    this.selectedCategories.delete(categoryId);
    this.updateHiddenField();

    event.target.parentElement.remove();
  }

  updateHiddenField() {
    document.getElementById("category-input").value = Array.from(this.selectedCategories).join(",");
  }

  addTag(categoryTitle, categoryId) {
    let tag = document.createElement("span");
    tag.className = "category-tag";
    tag.innerHTML = `${categoryTitle} <button type="button" data-value="${categoryId}" data-action="click->multiselect#remove">&times;</button>`;

    this.selectedTagsTarget.appendChild(tag);
  }
}
